import { uniqueId } from './pack-model.js'

/**
 * 表单新增条目的初始值，与 Demo 编辑器（StoryEditor.vue 的 add_* 函数）逐字段一致。
 * 文本字段留空由作者填写；严格校验要求的非空文本在填写前会报错，这是预期的提示。
 */

/** 新物品和它在开场状态里的位置：无人持有，放在第一个地点。 */
export function newItem(items, name, pack) {
  const id = uniqueId('item', items)
  return {
    item: { id, name, description: '' },
    state: { holder_id: null, location_id: pack.locations?.[0]?.id ?? '' },
  }
}

/** 新关系默认从第一位人物指向第二位，只有玩家知道。 */
export function newRelation(pack) {
  return {
    from_id: pack.characters?.[0]?.id ?? '',
    to_id: pack.characters?.[1]?.id ?? '',
    text: '',
    observer_ids: [pack.player_id],
  }
}

export function newSceneTemplate(templates, pack) {
  return {
    id: uniqueId('scene', templates),
    location_id: pack.locations?.[0]?.id ?? '',
    present_ids: [],
    situation: '',
    direction: '',
  }
}

export function newCue() {
  return { text: '', fact_ids: [] }
}

/** 触发条件与冷却轮数成对出现：加触发条件时一并写入冷却 1 轮。 */
export function newCueTrigger() {
  return { trigger: { kind: 'topic', entity_id: null, terms: [''] }, cooldown_turns: 1 }
}

/** 新建作品的标题、人物与地点默认名取作者界面语言，不改写已保存的作者内容。 */
export function newStoryNames(t) {
  return { title: t('storyCreate.untitled'), player: t('novelStudio.fields.player'), guide: t('novelStudio.fields.newCharacter'), location: t('novelStudio.fields.newLocation') }
}

/** Default prose is supplied by the shared translated control; identity rules stay here. */
export function newCharacter(pack, name) {
  const id = uniqueId('character', pack.characters)
  return {
    person: { id, name, public_profile: '', profile: { identity: '', appearance: '', personality: '', speech_style: '' },
      initial_goal: '', performance_cues: [], style_examples: [] },
    location_id: pack.locations?.[0]?.id ?? '',
  }
}

export function newLocation(pack, name) {
  return { id: uniqueId('location', pack.locations), name, description: '' }
}
